<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputEditor'
export default {
  name: 'DMobileEditor',
  extends: compoment
}
</script>
